import { 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  where, 
  Timestamp,
  updateDoc,
  doc,
  deleteDoc
} from 'firebase/firestore';
import { db } from './firebaseconfig';

const COLLECTION_NAME = 'appointments';

export const appointmentService = {
  // Create new appointment
  createAppointment: async (appointmentData) => {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...appointmentData,
        createdAt: Timestamp.now(),
        status: 'pending',
        userId: appointmentData.userId,
        timestamp: Timestamp.fromDate(new Date(appointmentData.date + ' ' + appointmentData.time))
      });
      return { id: docRef.id, ...appointmentData };
    } catch (error) {
      console.error("Error creating appointment: ", error);
      throw error;
    }
  },

  // Get user's appointments
  getUserAppointments: async (userId) => {
    try {
      const q = query(
        collection(db, COLLECTION_NAME),
        where("userId", "==", userId)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        date: doc.data().timestamp.toDate()
      }));
    } catch (error) {
      console.error("Error fetching appointments: ", error);
      throw error;
    }
  },

  // Update appointment
  updateAppointment: async (appointmentId, updateData) => {
    try {
      const appointmentRef = doc(db, COLLECTION_NAME, appointmentId);
      await updateDoc(appointmentRef, updateData);
      return { id: appointmentId, ...updateData };
    } catch (error) {
      console.error("Error updating appointment: ", error);
      throw error;
    }
  },

  // Delete appointment
  deleteAppointment: async (appointmentId) => {
    try {
      await deleteDoc(doc(db, COLLECTION_NAME, appointmentId));
      return appointmentId;
    } catch (error) {
      console.error("Error deleting appointment: ", error);
      throw error;
    }
  },

  // Check availability
  checkAvailability: async (repairCenterId, date, time) => {
    try {
      const timestamp = Timestamp.fromDate(new Date(date + ' ' + time));
      const q = query(
        collection(db, COLLECTION_NAME),
        where("repairCenterId", "==", repairCenterId),
        where("timestamp", "==", timestamp)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.empty;
    } catch (error) {
      console.error("Error checking availability: ", error);
      throw error;
    }
  }
};